@if (session(); as session) {
    <div class="row no-gutters mt-4 session-info p-2">
        <div class="col d-flex flex-row justify-content-between">
            <div class="main-blue">
                <div class="main-grey">
                    {{ "SellCamp.Dates" | translate }}
                </div>
                <div>
                    {{ session.sessionDaysFrom | bcDate: "MMM DD" }} -
                    {{ session.sessionDaysTo | bcDate: "MMM DD" }}
                </div>
            </div>
            @if (session.timeVariant; as timeVariant) {
                <div>
                    <div class="main-grey">
                        {{ "SellCamp.Details" | translate }}
                    </div>
                    <div class="main-blue">
                        <span class="mr-1"
                            >{{ timeVariantTranslation(timeVariant.type) }}
                        </span>
                        <span
                            >({{
                                timeVariant.timeFromInMinutes | timeDisplay
                            }}
                            -
                            {{
                                timeVariant.timeToInMinutes | timeDisplay
                            }})</span
                        >
                    </div>
                </div>
            }
            <div>
                <div class="main-grey">
                    {{ "SellCamp.AgeRange" | translate }}
                </div>
                <div class="main-blue">
                    <span>{{ session.ageRangeFromInMonths | age }}</span> -
                    <span>{{ session.ageRangeToInMonths | age }}</span>
                </div>
            </div>
        </div>
    </div>
}
